import { openBlock as y, createElementBlock as w, createElementVNode as v } from "//omikujistore.com/cdn/shop/t/10/assets/lib.vue.js?v=39460745490713962181759520844";
import { _, u as g } from "//omikujistore.com/cdn/shop/t/10/assets/v-useLocale-CrhIBLM-.js?v=104820010258233384051759520903";
import l from "//omikujistore.com/cdn/shop/t/10/assets/lib.axios.js?v=163496142447338752001759520843";
const m = {}, P = {
  "clip-rule": "evenodd",
  "fill-rule": "evenodd",
  "stroke-linejoin": "round",
  "stroke-miterlimit": "2",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
function h(e, s) {
  return y(), w("svg", P, s[0] || (s[0] = [
    v("path", { d: "m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" }, null, -1)
  ]));
}
const S = /* @__PURE__ */ _(m, [["render", h]]);
function E(e) {
  let s, o, a, n = !1;
  function u() {
    n || (s = e.style.getPropertyValue("overflow"), o = e.style.getPropertyValue("overflow-x"), a = e.style.getPropertyValue("overflow-y"), e.style.setProperty("overflow", "clip", "important"), e.style.setProperty("overflow-x", "clip", "important"), e.style.setProperty("overflow-y", "clip", "important"), n = !0);
  }
  function i() {
    n && (e.style.setProperty("overflow", s), e.style.setProperty("overflow-x", o), e.style.setProperty("overflow-y", a), n = !1);
  }
  return { lockElement: u, unlockElement: i };
}
function B() {
  var p, d;
  const { t: e } = g(), s = ((d = (p = window.Shopify) == null ? void 0 : p.routes) == null ? void 0 : d.root) ?? "/";
  async function o(r) {
    try {
      const t = await l.post(s + "cart/add.js", r, {
        responseType: "json",
        validateStatus: (c) => c == 200 || c == 422
      });
      return t.status == 422 ? { success: !1, reason: t.data.description } : { success: !0, added: t.data.items };
    } catch {
      return { success: !1, reason: e.general.an_error_occured };
    }
  }
  async function a(r, t = 1) {
    return await o({ items: [{ id: r, quantity: t }] });
  }
  async function n(r) {
    return r instanceof Array ? o({ items: r }) : await o({ items: [r] });
  }
  async function u() {
    try {
      return { success: !0, data: (await l.get(s + "cart.js", {
        responseType: "json",
        validateStatus: (t) => t == 200
      })).data };
    } catch {
      return { success: !1, reason: e.general.an_error_occured };
    }
  }
  async function i(r) {
    try {
      return { success: !0, data: (await l.post(s + "cart/change.js", r, {
        responseType: "json",
        validateStatus: (c) => c == 200
      })).data };
    } catch {
      return { success: !1, reason: e.general.an_error_occured };
    }
  }
  async function f() {
    try {
      const r = await l.post(s + "cart/update.js", null, {
        responseType: "json",
        validateStatus: (t) => t == 200
      });
      return { success: !0 };
    } catch {
      return { success: !1, reason: e.general.an_error_occured };
    }
  }
  return { add: a, addBulk: n, get: u, update: i, clear: f };
}
export {
  S as C,
  B as a,
  E as u
};
